import React from "react"
import { ListboxOption } from "@reach/listbox"

import { Icon } from "../../icon"

function Option({ label, ...rest }) {
  return (
    <ListboxOption label={label} {...rest}>
      <div className="body py-[5px] whitespace-pre-line">{label}</div>
      <div className="list-box__icon flex items-center justify-center w-8 h-8">
        <Icon aria-hidden className="text-violet" symbol="check" size={12} />
      </div>
    </ListboxOption>
  )
}

export default Option
